import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import {MrpProcessTemplateBOMContainerModel} from '../../../../../../models/aggregates/mrp-prodsys';


@Injectable({
  providedIn: 'root'
})
export class MrpProcessTemplateBOMService extends BaseApiTemplateService<MrpProcessTemplateBOMContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/mrp-process-template-boms"

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/mrp-process-template-boms"
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/mrp-process-template-boms"
    this.httpClient = http;
  }

}
